import React, {useState } from 'react';
import Axios from 'axios';
import useSWR from 'swr'
import { CATviewNgrams } from '../CATviewNgrams/CATviewNgrams';
// import { concat } from 'mathjs';

export interface MyComponentProps {
  // Define your prop types here
  displayType: string, // either "count" or "text"
  expressionid: string
}




export const ConvolutionMatches: React.FC<MyComponentProps> = (props) => {

  const axiosFetcher = (url: string, expressionid: string) => Axios.get(url).then((res) => {
    const newObject: any = {}
    const topLevelDict: any = {}
    
    Object.keys(res.data).forEach((key) => {
      
      const sourceTopLevel: string = res.data[key].sourceTopLevel
      const sourceTopLevelTitle: string = res.data[key].sourceMetadata?.authorTitle + ", " + sourceTopLevel || sourceTopLevel
      topLevelDict[sourceTopLevel] = sourceTopLevelTitle
      const sourceItem: string = res.data[key].sourceItem
      const sourceItemTitle: string = res.data[key].sourceMetadata?.authorTitle + ", " + res.data[key].sourceMetadata?.longTitle || sourceItem
      const matchItem: string = res.data[key].targetItem
      const matchItemTitle: string = res.data[key].targetMetadata?.authorTitle + ", " + res.data[key].targetMetadata?.longTitle || matchItem
  
      if (sourceTopLevel === props.expressionid || sourceItem === props.expressionid || !props.expressionid){
      // Check if the sourceTopLevel key exists, if not, initialize it
      if (!newObject[sourceTopLevel]) {
        newObject[sourceTopLevel] = {};
      }
      // Check if the sourceItem key exists within sourceTopLevel, if not, initialize it
      const matchPair = sourceItem + "==>" + matchItem
      if (!newObject[sourceTopLevel][matchPair]) {
        newObject[sourceTopLevel][matchPair] =  {
        count: 1,
        source: sourceItem,
        target: matchItem,
        sourceTitle: sourceItemTitle,
        targetTitle: matchItemTitle,
      };
      } 
      // Now that we're sure the structure exists, push the key
      newObject[sourceTopLevel][matchPair].count += 1;
      newObject[sourceTopLevel][matchPair].source = sourceItem;
      newObject[sourceTopLevel][matchPair].target = matchItem;
      newObject[sourceTopLevel][matchPair].sourceTitle = sourceItemTitle;
      newObject[sourceTopLevel][matchPair].targetTitle = matchItemTitle;
    }
  
  
      
  
    })
    
    let clustersArray: any[] = []
      Object.keys(newObject).forEach((tl) => {
        const labelCountArray = Object.keys(newObject[tl]).map((item) => {
          return {
            item: item,
            count: newObject[tl][item].count,
            source: newObject[tl][item].source,
            sourceTitle: newObject[tl][item].sourceTitle,
            target: newObject[tl][item].target,
            targetTitle: newObject[tl][item].targetTitle,
          }
        })
        clustersArray = clustersArray.concat(labelCountArray)
      })
      clustersArray.sort((a, b) => b.count - a.count);
      
    return {
      topLevel: newObject,
      clusters: clustersArray,
      topLevelDict: topLevelDict
    }
  })


  const [showItems, setShowItems] = useState<any>({})
  const [showBlocks, setShowBlocks] = useState<any>({})
  const [showCATviewNgrams, setShowCATviewNgrams] = useState<any>({})
  //TODO: clustersList will need to published and an independent webservice; 
  //it will not be reachable when this component travels
  //const {data: data, error, isLoading } = useSWR('./clustersListConvolution-2025-01-18.json', axiosFetcher)
  // const {data: data, error, isLoading } = useSWR('https://gist.githubusercontent.com/jeffreycwitt/b0756e33a22d9995080d7c5f17fe064a/raw/ac84c8e302a0e9d4dd5eb29aa81f4992fae907d3/clustersListConvolution.json', axiosFetcher, 
  //    {
  //   revalidateOnFocus: false,
  //   revalidateOnReconnect: false,
  //   refreshInterval: 0,
  //   keepPreviousData: false, // <--- add this line
  // }
  // )
  const {data, error, isLoading } = useSWR(
  ['https://gist.githubusercontent.com/jeffreycwitt/b0756e33a22d9995080d7c5f17fe064a/raw/clustersListConvolution.json', props.expressionid],
  ([url, expressionid]) => axiosFetcher(url, expressionid),
  {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    refreshInterval: 0,
    keepPreviousData: false,
  }
)
  


  
  const displayItem = (itemObject:any) => {
    const items = Object.keys(itemObject)
    .sort((a, b) => itemObject[b].count - itemObject[a].count) // Sort descending by count
    .map((itemkey: any) => {
      // const source: string = item.split("==>")[0]
      // const target: string = item.split("==>")[1]
      const item = itemObject[itemkey]
      const target: string = item?.target
      const source: string = item?.source

      return (
      <div key={item}>
        <br/>
        <span onClick={() => setShowBlocks({...showBlocks, [item]: !showBlocks[item]})}>
          clustersCount = {item.count}</span>
          <br/>
          {props.expressionid && props.expressionid === item.source ? 
          item.sourceTitle + "==>" + item.targetTitle
          :
          item.sourceTitle + "==>" + item.targetTitle
          }
        <br/>
        {(!showCATviewNgrams || (showCATviewNgrams.source !== source || showCATviewNgrams.match !== target)) && <span onClick={() => setShowCATviewNgrams({source: source, match: target})}>viz</span>}
        {(showCATviewNgrams && showCATviewNgrams.source === source && showCATviewNgrams.match === target) && <span onClick={() => setShowCATviewNgrams({})}>hide viz</span>}
        {(showCATviewNgrams && showCATviewNgrams.source === source && showCATviewNgrams.match === target) && <CATviewNgrams expressionid={"http://scta.info/resource/" + source} expressionConstraint={"http://scta.info/resource/" + target}/>}
        
      </div>
      )
    })
    return items
  }

  const displayByCount = (clustersList:any[]) => {
    const clustersDisplay = clustersList.map((c) => {
      // const source: string = c.item.split("==>")[0]
      // const target: string = c.item.split("==>")[1]
      const source: string = c.source
      const target: string = c.target
      return(
      <div key={"count-" + c.item}>
        <br/>
        <span>clustersCount = {c.count}</span>
          <br/> 
          {props.expressionid && props.expressionid === c.source ? 
          c.targetTitle
          :
          c.sourceTitle + "==>" + c.targetTitle
          }
          <br/>
        {(!showCATviewNgrams || (showCATviewNgrams.source !== source || showCATviewNgrams.match !== target)) && <span onClick={() => setShowCATviewNgrams({source: source, match: target})}>viz</span>}
        {(showCATviewNgrams && showCATviewNgrams.source === source && showCATviewNgrams.match === target) && <span onClick={() => setShowCATviewNgrams({})}>hide viz</span>}
        {(showCATviewNgrams && showCATviewNgrams.source === source && showCATviewNgrams.match === target) && <CATviewNgrams expressionid={"http://scta.info/resource/" + source} expressionConstraint={"http://scta.info/resource/" + target}/>}
        
      </div>
      )
    })
    return clustersDisplay
  }

  // Handle loading and error states
  if (error) return <div>Error loading text</div>;
  if (isLoading) return <div>Loading...</div>;
  return(
    
      <div>
        {props.displayType === "count" ? 
        <div>
        {data && displayByCount(data?.clusters)}
        </div>
        :
        <div>
        {Object.keys(data?.topLevel).map((key) => {
          return (
          <div key={key}>
            <p onClick={() => setShowItems({...showItems, [key]: !showItems[key]})}>{(props.expressionid && props.expressionid !== key) ? data?.topLevelDict[key] + ", " + props.expressionid : data?.topLevelDict[key]}</p>
            {!!showItems[key] && displayItem(data?.topLevel[key])}
          </div>
          )
        })
        }
        </div>}
      
    </div>
      
  
  )
}